import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';

const defaultMenuToRoute: Record<string, string> = {
  ragflow: '/ragflow',
  chat: '/chat',
  planner: '/planner',
  documents: '/documents',
  templates: '/templates',
  plugins: '/plugins',
  plan: '/plan',
};

function computeDefaultRedirect(): string {
  const originalDefaultRedirect = environment.standalone
    ? '/plan'
    : (environment.menu?.chat ? '/chat' : '/dashboard');

  const defaultMenu = environment.defaultMenu as keyof typeof defaultMenuToRoute | undefined;
  const defaultMenuRoute = defaultMenu ? defaultMenuToRoute[defaultMenu] : undefined;
  const defaultMenuEnabled = defaultMenu ? (environment.menu as any)?.[defaultMenu] === true : false;

  return defaultMenuRoute
    ? (defaultMenuEnabled ? defaultMenuRoute : '/dashboard')
    : originalDefaultRedirect;
}

function isRouteEnabledByMenu(path: string): boolean {
  const key = (Object.keys(defaultMenuToRoute) as Array<keyof typeof defaultMenuToRoute>)
    .find(k => defaultMenuToRoute[k] === path);

  if (!key) return true;
  return (environment.menu as any)?.[key] === true;
}

@Injectable({ providedIn: 'root' })
export class MenuEnabledGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree {
    const menuKey = route.data?.['menuKey'] as keyof typeof environment.menu | undefined;

    if (!menuKey) return true;

    const enabled = (environment.menu as any)?.[menuKey] === true;
    if (enabled) return true;

    const fallback = computeDefaultRedirect();
    const finalTarget = isRouteEnabledByMenu(fallback) ? fallback : '/dashboard';
    return this.router.parseUrl(finalTarget);
  }
}
